import React from "react";
import Categories from "./Categories";
import LocationsFilters from "./Location";

class Filters extends React.Component {
  render() {
    return (
      <div className="t-container-fluid banner__filters_container">
        <div className="t-row">
          <div className="offset-md-2 offset-lg-2 t-col-sm-12 t-col-lg-8 t-col-md-8 banner__filter__categories__container">
            <Categories />
            <div className="banner__filter__in__text"></div>
            <LocationsFilters />
          </div>
        </div>
      </div>
    );
  }
}

export default Filters;
